const QuadrantDecorator = ({ ...rest }) => (
  <svg width="21" height="20" viewBox="0 0 21 20" {...rest}>
    <path
      d="M20.2451 0.166016L20.2451 19.166L0.905831 19.166C0.905832 8.67261 9.41242 0.166015 19.9058 0.166016L20.2451 0.166016Z"
      fill="currentColor"
    />
  </svg>
);

export { QuadrantDecorator };
